import { render, staticRenderFns } from "./Hzhb.vue?vue&type=template&id=25a39704&scoped=true&"
import script from "./Hzhb.vue?vue&type=script&lang=js&"
export * from "./Hzhb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a39704",
  null
  
)

export default component.exports